import type { LegendLookup } from '@app/components/Molecules/Legend'
import type { VulnerabilityData } from '@app/components/Molecules/MapView/RiskMapView/RiskMapView'
import type { VisibleAssets } from '@app/components/Molecules/MapView/RiskMapView/RiskMapView.utilities'
import type { RegionOption } from '@app/components/Molecules/RegionFilter'
import type { MapLayerStyles } from '@app/types/mapTypes'
import type { MapLayer } from '@app/types/layerTypes'
import type { Map } from 'mapbox-gl'

import { renderLayersInOrder } from '@app/components/Molecules/MapView/RiskMapView/Layers'
import { generateInformationLayerPalettes } from '@app/components/Molecules/MapView/RiskMapView/RiskMapView.utilities'

interface RenderRiskLayersProps {
  map: Map
  layers: MapLayer[]
  mapLayerStyles: MapLayerStyles
  visibleAssets: VisibleAssets
  vulnerabilityData: VulnerabilityData
  legendsData: LegendLookup
  regionMasks: RegionOption[] | null
  hasFilters: boolean
  applyVulnerabilityData: boolean
}

export function renderRiskLayers({
  map,
  layers,
  mapLayerStyles,
  visibleAssets,
  vulnerabilityData,
  legendsData,
  regionMasks,
  hasFilters,
  applyVulnerabilityData,
}: RenderRiskLayersProps) {
  const informationLayerPalettes = generateInformationLayerPalettes(legendsData)

  renderLayersInOrder(
    map,
    layers,
    mapLayerStyles,
    visibleAssets,
    vulnerabilityData,
    legendsData,
    informationLayerPalettes,
    regionMasks,
    hasFilters,
    applyVulnerabilityData,
  )
}
